// © Microsoft Corporation. All rights reserved.
function supportsIntersectionObserver(): boolean {
    return (
        "IntersectionObserver" in global &&
        "IntersectionObserverEntry" in global &&
        "intersectionRatio" in IntersectionObserverEntry.prototype
    );
}

function loadPolyfills(): Promise<any> {
    const polyfills = [];

    if (!supportsIntersectionObserver()) {
        polyfills.push(import("intersection-observer"));
    }

    return Promise.all(polyfills);
}

const loadObserver = (observer) => {
    return loadPolyfills().then(observer);
};

export default loadObserver;